import React, {useState} from 'react';
import NavbarLocationForm from "../../../../Navbar/NavbarLocationForm";
import {
    ConfigAddressApi,
    ConfigApi,
    LocationCheckApi,
    OrderType,
    StoreConfigCoordinatesApi
} from "../../../../../services/Api/types";
import {ReactComponent as LocationIco} from "../../../../../../images/icons/location.svg";
import {useTranslation} from "react-i18next";
import {formatMoney} from "../../../../Common/Money";
import i18n from "i18next";
import {api} from "../../../../../services/Api/api";
import {useGeolocation} from "../../../../../hooks/useGeolocation";

interface Props {
    currentType: "" | OrderType;
    address: ConfigAddressApi;
    setAddress: React.Dispatch<React.SetStateAction<ConfigAddressApi>>;
    errors: { field: string, code: string }[];
    setErrors: React.Dispatch<React.SetStateAction<{
        field: string
        code: string
    }[]>>;
    config: ConfigApi | undefined;
    setCoordinates: React.Dispatch<React.SetStateAction<StoreConfigCoordinatesApi | undefined>>;
}

const CartChangeOrderDetailsDeliveryAddressModal = ({
                                                        currentType,
                                                        address,
                                                        setAddress,
                                                        errors,
                                                        setErrors,
                                                        config,
                                                        setCoordinates
                                                    }: Props) => {
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    const [locationData, setLocationData] = useState<LocationCheckApi | undefined>();
    const [forceUpdateAddressFormValue, setForceUpdateAddressFormValue] = useState(false);
    const {getPosition, handleGeolocationError} = useGeolocation();

    if (currentType !== OrderType.DELIVERY) return <></>;

    const handleGeolocation = async () => {
        try {
            setLoading(true);
            const position = await getPosition();
            setCoordinates(position.coords);
            const {latitude, longitude} = position.coords;
            const res = await api.getAddressByCoordinates({latitude, longitude});
            setAddress({
                street: res.street ?? "",
                city: res.city ?? "",
                country: res.country ?? "",
                zip_code: res.zip_code ?? "",
                flat_nr: res.flat_nr ?? "",
                build_nr: res.build_nr ?? "",
            });
            setForceUpdateAddressFormValue(true);
        } catch (error) {
            handleGeolocationError(error as GeolocationPositionError);
        } finally {
            setLoading(false);
        }
    }

    const handleOnCheckLocationAddress = (data: LocationCheckApi) => {
        setLocationData(data);
    };

    const getDeliveryPrice = () => {
        let result = "";

        if (locationData?.delivery_price_money) {
            result += ` ${t("modules.cart.field.cost.title")}: ${formatMoney(locationData.delivery_price_money, i18n)}`;
        }
        if (locationData?.free_delivery_price_money) {
            result += ` (${t("modules.cart.field.free_delivery_cost.title")}: ${formatMoney(locationData.free_delivery_price_money, i18n)})`;
        }

        return result;
    }

    return (
        <div className="mt-4">
            <div className="d-flex align-items-center justify-content-between gap-2 mb-3">
                <h1 className="h5 mb-0">{t("modules.cart.field.delivery_address.title")}</h1>
                <button type="button"
                        className={`geolocation-btn btn btn-outline-primary btn-spinner${loading ? " loading" : ""}`}
                        onClick={handleGeolocation} aria-label={t("modules.multistore.field.geolocation.title")}>
                    <span className="left spinner-border spinner-border-sm" aria-hidden="true"/>
                    {!loading && (<LocationIco aria-hidden="true"/>)}
                </button>
            </div>
            <NavbarLocationForm config={config}
                                onErrors={setErrors}
                                onChange={setAddress}
                                errors={errors}
                                handleOnCheckLocationAddress={handleOnCheckLocationAddress}
                                forceCheckLocationAddressAtStart={true}
                                address={address}
                                forceUpdateAddressFormValue={forceUpdateAddressFormValue}
                                setForceUpdateAddressFormValue={setForceUpdateAddressFormValue}
            />
            {
                locationData?.in_delivery_area && (
                    <span className="fw-normal">
                        <span className="text-success">{t("modules.cart.field.delivery_available.title")}.</span>
                        {getDeliveryPrice() && <span>{getDeliveryPrice()}</span>}
                    </span>
                )
            }
        </div>
    )
}

export default CartChangeOrderDetailsDeliveryAddressModal;